import { useEffect } from 'react';
import { useAppContext } from './AppContext';
import { setAppContextToken, setSessionLogout, setSessionTimeoutHandler } from '../services/Api';

const ApiSessionHandler = () => {
    const { sessionTimeoutLogout, logout, setToken } = useAppContext();

    useEffect(() => {
        setSessionTimeoutHandler(sessionTimeoutLogout);
        setSessionLogout(logout);
        setAppContextToken(setToken);
    }, [sessionTimeoutLogout, logout, setToken]);

    return null; // This component doesn't render anything
};

export default ApiSessionHandler;
